var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 15.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z",
    fill: "#EA001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z",
    fill: "#FFA200",
    fillOpacity: 0.8
  })));
};
export default SvgMastercard;